// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"161":"85c81530","272":"8044687b","461":"5893b764","648":"5893b764","674":"5893b764","710":"200065f7","769":"5893b764","825":"ad743700","914":"f5f5892a"}[chunkId] + ".chunk.css";
};